import { useParams } from "react-router-dom"
import { AESDecrypt } from "../../encrypt-util"
import EBL from "../../app/features/ebl/components/EBL"

const map = {
    
    'TF' : <EBL/>,
    'EDTR' : <EBL/>,
    'AT' : <EBL/>,
    'EC' : <EBL/>,
    'EDEC' : <EBL/>,
    'AM' : <EBL/>,
    'WD' : <EBL/>,
    'SRDV' : <EBL/>,
    'CVPP' : <EBL/>,


}
const EInstructionMapper =()=>{
    const {encrypt} = useParams()
    // const instruction = AESDecrypt(encrypt)
    const eInstruction = AESDecrypt(encrypt); 
    // const eInstruction = 1 
    return map[eInstruction]
}

export default EInstructionMapper